import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminFacilityManager.css";

const API = "/api/facility";

const AdminFacilityManager = () => {

const [facilities, setFacilities] = useState([]);

const [title, setTitle] = useState("");
const [description, setDescription] = useState("");
const [image, setImage] = useState(null);
const [preview, setPreview] = useState("");

const [editId, setEditId] = useState(null);

const [search, setSearch] = useState("");

const [currentPage, setCurrentPage] = useState(1);
const recordsPerPage = 5;

/* LOAD DATA */

const loadData = async () => {

try {

  const res = await axios.get(API);

  setFacilities(res.data);

} catch (err) {

  console.error(err);

}


};

useEffect(() => {
loadData();
}, []);

/* RESET FORM */

const resetForm = () => {
setTitle("");
setDescription("");
setImage(null);
setPreview("");
setEditId(null);

const fileInput = document.getElementById("facilityImage");
if (fileInput) fileInput.value = "";
};

/* IMAGE PREVIEW */

const handleImageChange = (e) => {
const file = e.target.files[0];

setImage(file);

if (file) {

  const reader = new FileReader();

  reader.onloadend = () => {

    setPreview(reader.result);

  };

  reader.readAsDataURL(file);

}
};

/* SUBMIT */

const submitForm = async (e) => {
e.preventDefault();

const form = new FormData();

form.append("title", title);
form.append("description", description);

if (image) form.append("image", image);

try {

  if (editId) {

    await axios.put(API + "/" + editId, form);

  } else {

    await axios.post(API, form);

  }

  resetForm();
  loadData();

} catch (err) {

  console.error(err);

}
};

/* DELETE */

const deleteItem = async (id) => {
if (!window.confirm("Delete this facility?")) return;

await axios.delete(API + "/" + id);

loadData();
};

/* EDIT */

const editItem = (item) => {
setTitle(item.title);
setDescription(item.description);
setEditId(item.id);

setPreview(
  BASE_URL + "/uploads/facility/" + item.image
);

window.scrollTo({
  top: 0,
  behavior: "smooth"
});
};

/* SEARCH FILTER */

const filteredFacilities = facilities.filter((item) =>
item.title.toLowerCase().includes(search.toLowerCase()) ||
item.description.toLowerCase().includes(search.toLowerCase())
);

/* PAGINATION */

const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;

const currentFacilities = filteredFacilities.slice(
indexOfFirst,
indexOfLast
);

const totalPages = Math.ceil(
filteredFacilities.length / recordsPerPage
);

return (
<div className="facility-admin">

  <h2>Facility Manager</h2>


  {/* FORM */}

  <form onSubmit={submitForm}>

    <input
      type="text"
      placeholder="Facility Title"
      value={title}
      onChange={(e)=>setTitle(e.target.value)}
      required
    />

    <textarea
      placeholder="Facility Description"
      value={description}
      onChange={(e)=>setDescription(e.target.value)}
      rows="4"
    />

    <input
      id="facilityImage"
      type="file"
      onChange={handleImageChange}
    />


    {preview && (

      <div className="preview-box">
        <img src={preview} alt="preview"/>
      </div>

    )}


    <div className="btn-group">

      <button type="submit" className="add-btn">
        {editId ? "Update Facility" : "Add Facility"}
      </button>

      <button
        type="button"
        className="reset-btn"
        onClick={resetForm}
      >
        Reset
      </button>

    </div>

  </form>



  {/* SEARCH */}

  <div className="search-box">

    <input
      type="text"
      placeholder="Search facility..."
      value={search}
      onChange={(e)=>setSearch(e.target.value)}
    />

  </div>



  {/* TABLE */}

  <table>

    <thead>

      <tr>
        <th>ID</th>
        <th>Image</th>
        <th>Title</th>
        <th>Description</th>
        <th>Action</th>
      </tr>

    </thead>

    <tbody>

      {currentFacilities.map((item)=>(

        <tr key={item.id}>

          <td>{item.id}</td>

          <td>

            <img
              src={
                BASE_URL + "/uploads/facility/" + item.image
              }
              alt=""
            />

          </td>

          <td>{item.title}</td>

          <td className="desc-col">
            {item.description}
          </td>

          <td>

            <button
              className="edit-btn"
              onClick={()=>editItem(item)}
            >
              Edit
            </button>

            <button
              className="delete-btn"
              onClick={()=>deleteItem(item.id)}
            >
              Delete
            </button>

          </td>

        </tr>

      ))}

    </tbody>

  </table>



  {/* PAGINATION */}

  <div className="pagination">

    {Array.from({length: totalPages}, (_, i) => (

      <button
        key={i}
        className={
          currentPage === i + 1 ? "active-page" : ""
        }
        onClick={()=>setCurrentPage(i + 1)}
      >
        {i + 1}
      </button>

    ))}

  </div>


</div>
);
};

export default AdminFacilityManager;
